import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="t-map"
export default class extends Controller {
  static targets = ["container"]
  static values = {
    containerId: { type: String, default: "map-container" }
  }

  connect() {
    this._loadScript();
  }

  _initMap() {
    // Coordinates were retrieved from here: https://lbs.qq.com/getPoint/#S
    const center = new TMap.LatLng(34.632913, 109.20782);

    // https://lbs.qq.com/webDemoCenter/glAPI/glMap/createMap
    const map = new TMap.Map(this.containerIdValue, {
        rotation: 20,
        pitch: 30, //设置俯仰角度（0~45）
        zoom: 15,//设置地图缩放级别
        center: center//设置地图中心点坐标
    });

    // https://lbs.qq.com/webDemoCenter/glAPI/glMarker/sampleMarker
    const marker = new TMap.MultiMarker({
      map: map,
      styles: {
        // 点标记样式
        marker: new TMap.MarkerStyle({
          width: 20, // 样式宽
          height: 30, // 样式高
          anchor: { x: 10, y: 30 }, // 描点位置
        }),
      },
      geometries: [
        // 点标记数据数组
        {
          // 标记位置(纬度，经度，高度)
          position: center,
          id: 'marker',
        },
      ],
    });
  }

  _loadScript() {
    const script = document.createElement("script");
    script.src = "https://map.qq.com/api/gljs?v=1.exp&key=QXLBZ-5ONKW-3LAR4-34WUQ-IRGVO-2SFF4";
    script.onload = () => {
      this._initMap();
    };
    document.head.appendChild(script);
  }
}
